/**
 * Created by fers on 01.07.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import '../screen-settings/ScreenSettings.scss';
import BoxDisplayer from './BoxDisplayer.react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default class LineDisplayer extends React.Component {

    static propTypes = {
        isPreview: PropTypes.bool,
        relay: PropTypes.object.isRequired,
        viewsWithData: PropTypes.array.isRequired,
    };

    static defaultProps = {
        isPreview: false,
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    createElement(viewWithData) {
        return (
            <BoxDisplayer isPreview={this.props.isPreview} relay={this.props.relay} viewWithData={viewWithData} />
        );
    }

    render() {
        return (
            <div className={"panelColumns panelColumnsInRows " + (this.props.isPreview ? "panelColumnsIsPreview" : "")}>
                <div className="panelColumnsInRowsHolder">
                    {this.props.viewsWithData.map((viewWithData, idx) => {
                        let className = "panelColumnsInRowsWrapper";

                        return (
                            <div className={className} key={idx}>
                                {this.createElement(viewWithData)}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
